// @flow

export default {
    HOUSE: 0,
    APARTMENT: 1,
    PLOTS: 2,
    INDUSTRY: 3
};